import angular from 'angular'
import template from '../components/template.html'

angular.module('nominas.cotizaciones')
  .config(Config);

function Config($stateProvider) {
  $stateProvider.state('nominas.cotizaciones', {
    url: '/prenominas?{fecha_inicio:date}&{fecha_fin:date}&:ids_empresas',
    data: {
      title: 'Prenóminas',
    },
    params: {
      ids_empresas: {
        array: true,
      },
    },
    resolve: {
      empresas: ['$catalogos', function ($catalogos) {
        return $catalogos
          .get('empresas');
      }],
      nominasCotizaciones: ['NominasCotizaciones', '$stateParams', function (NominasCotizaciones, $stateParams) {
        let fecha_inicio = $stateParams.fecha_inicio,
          fecha_fin = $stateParams.fecha_fin,
          ids_empresas = $stateParams.ids_empresas;

        return fecha_inicio && fecha_fin && ids_empresas ? NominasCotizaciones.lista(
          fecha_inicio,
          fecha_fin,
          ids_empresas,
        ) : undefined;
      }],
    },
    template: template,
    controllerAs: '$ctrl',
    controller: Component,
  });
}

function Component(nominasCotizaciones, empresas, $state, $moment, $stateParams, $location) {
  let $ctrl = this;
  $ctrl.data = nominasCotizaciones;
  $ctrl.empresas = empresas;
  let hoy = $moment().toDate(),
    antes = $moment().subtract(1, 'months').toDate();

  $ctrl.opciones = {
    fecha_inicio: $stateParams.fecha_inicio || antes,
    fecha_fin: $stateParams.fecha_fin || hoy,
    empresas: $stateParams.ids_empresas || [],
  };

  $ctrl.agregarCotizacion = agregarCotizacion;
  $ctrl.obtenerInformacion = obtenerInformacion;

  function agregarCotizacion(folio) {
    $state.go('^.cotizacion.informacion', {
      folio: folio,
    });
  }

  function obtenerInformacion() {
    $location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      ids_empresas: $ctrl.opciones.empresas,
    });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cotizaciones/routes/nominas-cotizaciones.js